export class PaymentDiscount {
}
